import { render, staticRenderFns } from "./formBank.vue?vue&type=template&id=4a3595f6&scoped=true"
import script from "./formBank.vue?vue&type=script&lang=js"
export * from "./formBank.vue?vue&type=script&lang=js"
import style0 from "./formBank.vue?vue&type=style&index=0&id=4a3595f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3595f6",
  null
  
)

export default component.exports